import { useEffect } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

// Gate for private routes: only a signed-in (allowlisted) owner may view them.
// Non-authed visitors get the sign-in dialog; the backend allowlist decides who can actually pass.
export const RequireAuth = ({ children }) => {
  const { isAuthed, exchanging, openAuth } = useAuth();

  useEffect(() => {
    if (!isAuthed && !exchanging) openAuth();
  }, [isAuthed, exchanging, openAuth]);

  if (isAuthed) return children;

  return (
    <div data-testid="auth-required-gate" className="min-h-screen grid place-items-center bg-background px-6 text-center">
      <div className="max-w-sm animate-pop">
        <span className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl bg-accent/15 text-accent">
          <Lock className="h-7 w-7" />
        </span>
        <h1 className="font-heading text-2xl font-bold">This Duckify is private</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Please sign in to view this page — access is limited to the studio owner.
        </p>
        <Button data-testid="gate-signin-btn" onClick={openAuth} className="mt-6 rounded-full px-6">
          Sign in
        </Button>
      </div>
    </div>
  );
};
